import { useEffect, useState } from 'react'

export interface WhosePicker {
  open: boolean
  toggle: () => void
  close: () => void
}

/** Whether the Whose bar is open; Escape or a press anywhere outside the button and the bar closes it. */
export function useWhosePicker(): WhosePicker {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (!open) return
    const outside = (e: PointerEvent) => {
      // the button and the bar carry data-whose-picker: a press on either is not a press outside
      if (e.target instanceof Element && e.target.closest('[data-whose-picker]')) return
      setOpen(false)
    }
    const escape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', outside)
    document.addEventListener('keydown', escape)
    return () => {
      document.removeEventListener('pointerdown', outside)
      document.removeEventListener('keydown', escape)
    }
  }, [open])
  return { open, toggle: () => setOpen((v) => !v), close: () => setOpen(false) }
}
